import React from "react";
import "./newsevent.css";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

// Helper function to limit description to n words
const getShortDescription = (text, wordLimit = 15) => {
  if (!text) return "";
  const words = text.split(" ");
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : text;
};

const BlogList = ({ posts = [] }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta"; // get selected language from header

  return (
    <div className="blog-list-section">

      {/* PAGE HEADING BASED ON LANGUAGE */}
      <h2 className="blog-list-title">
        {lang === "en"
          ? "Our Events – Important Social & Cultural Updates"
          : "எங்களின் நிகழ்வுகள் – சமூகம் மற்றும் கலாச்சாரத்திற்கான முக்கிய நிகழ்வுகள்"}
      </h2>

      {/* BLOG LIST */}
      <div className="blog-list">
        {posts.map((post, index) => (
          <motion.div
            className="blog-card"
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            {/* IMAGE */}
            <div className="blog-img">
              <img
  src={post.image}
  alt={post.title}
  onError={(e) => (e.target.src = "/default-image.png")}
/>

            </div>

            {/* CONTENT */}
            <div className="blog-content">
              <a href={post.link} className="blog-title">
                {post.title}
              </a>

              <p className="blog-desc">
                {getShortDescription(post.description, 15)}
              </p>

              <div className="blog-meta">
                <span>
                  {new Date(post.date).toLocaleDateString(
                    lang === "en" ? "en-IN" : "ta-IN",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </span>
              </div>

              <div className="blog-footer">
                <a href={post.link} className="read-more">
                  {lang === "en" ? "Read More →" : "மேலும் படிக்க →"}
                </a>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
